import { render, staticRenderFns } from "./ThgProofs.vue?vue&type=template&id=38055457&scoped=true"
import script from "./ThgProofs.vue?vue&type=script&lang=ts"
export * from "./ThgProofs.vue?vue&type=script&lang=ts"
import style0 from "./ThgProofs.vue?vue&type=style&index=0&id=38055457&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38055457",
  null
  
)

export default component.exports